import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Button from '../Button';
import { AddProduct } from '../../store/Slices/gifts/basketSlice';
import { isSantaLetterProduct } from '../../utils/Gifts/products';

const AddToBasketButton = ({ product, isOutlained = false }) => {
  const dispatch = useDispatch();
  const addToBasketClicked = () => {
    dispatch(AddProduct(product));
  };

  if (isSantaLetterProduct(product)) {
    return null;
  }

  return (
    <Button
      type="primary"
      isOutlained={isOutlained}
      onClick={() => addToBasketClicked()}
      data-component="add-to-basket-button"
    >
      Add to basket
    </Button>
  );
};

AddToBasketButton.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    title: PropTypes.string,
    categoryIds: PropTypes.arrayOf(PropTypes.number),
    image: PropTypes.object,
    url: PropTypes.object,
    shortDescription: PropTypes.string,
    actionImage: PropTypes.object,
    actionDescription: PropTypes.string,
    annotation: PropTypes.string,
    giftsInBundle: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  isOutlained: PropTypes.bool,
};

export default AddToBasketButton;
